<template>
    <div class="ImageTranslation-container">
        <div class="text-item">
            <span>源语言：</span>
            <el-input v-model="sourceLanguage" />
        </div>
        <div class="text-item">
            <span>目标语言：</span>
            <el-input v-model="targetLanguage" />
        </div>
        <el-button @click="translationAll" type="primary">翻译图片</el-button>
        <!-- 添加状态 -->
        <span class="status-text">
            {{ status=='' ? '' : (status=='translating' ? '翻译中...' : (status=='success' ? '翻译成功，正在替换图片' : '翻译失败')) }}
        </span>
    </div>
</template>

<script>
class ConcurrentRunner {
    constructor(maxConcurrency = 5) {
        this.maxConcurrency = maxConcurrency; // 最大并发数
        this.running = 0; // 当前正在运行的任务数
        this.queue = []; // 等待队列
    }

    // 添加任务到队列
    addTask(taskFn) {
        return new Promise((resolve, reject) => {
            const run = async () => {
                this.running++;
                try {
                    const result = await taskFn();
                    resolve(result);
                } catch (err) {
                    reject(err);
                } finally {
                    this.running--;
                    // 下一个任务开始
                    if (this.queue.length > 0) {
                        const nextTask = this.queue.shift();
                        nextTask();
                    }
                }
            };

            if (this.running < this.maxConcurrency) {
                run();
            } else {
                this.queue.push(run);
            }
        });
    }
}
export default {
    name: 'ImageTranslation',
    components: {},
    props: {
        sourceLanguage: {
            type: String,
            default: 'en',
        },
        targetCountry: {
            type: String,
            required: true,
        },
        imgList: {
            type: Array,
            default: () => [],
        },
        // 是否获取父组件数据
        getParentData:{
            type: Function,
        }
    },
    data() {
        return {
            status:'',
            targetLanguage: '',
            countryLangMap: {
                EUR: "en", // 默认欧洲用英语
                NA: "en",  // 北美默认英语
                MX: "es",  // 墨西哥 -> 西班牙语
                CA: "en",  // 加拿大 -> 英语（可扩展成fr）
                US: "en",  // 美国 -> 英语
                DE: "de",  // 德国 -> 德语
                FR: "fr",  // 法国 -> 法语
                GB: "en",  // 英国 -> 英语
                IT: "it",  // 意大利 -> 意大利语
                ES: "es",  // 西班牙 -> 西班牙语
                JP: "ja",  // 日本 -> 日语
                NL: "nl",  // 荷兰 -> 荷兰语
                AU: "en",  // 澳大利亚 -> 英语
                SE: "sv",  // 瑞典 -> 瑞典语
                AE: "ar",  // 阿联酋 -> 阿拉伯语
                SG: "en",  // 新加坡 -> 英语
                PL: "pl",  // 波兰 -> 波兰语
                SA: "ar",  // 沙特 -> 阿拉伯语
                BR: "pt",  // 巴西 -> 葡萄牙语
                PH: "tl",  // 菲律宾 -> 塔加洛语
                MY: "ms",  // 马来西亚 -> 马来语
                TW: "zh-tw", // 台湾 -> 中文繁体
                ID: "id",  // 印度尼西亚 -> 印尼语
                TH: "th",  // 泰国 -> 泰语
                VN: "vi",  // 越南 -> 越南语
                CO: "es",  // 哥伦比亚 -> 西班牙语
                CL: "es",  // 智利 -> 西班牙语
                AR: "es",  // 阿根廷 -> 西班牙语
                TR: "tr",  // 土耳其 -> 土耳其语
                KR: "ko",  // 韩国 -> 韩语
                BE: "nl",  // 比利时 -> 荷兰语（部分地区法语）
                EG: "ar",  // 埃及 -> 阿拉伯语
                IN: "en",  // 印度 -> 英语（也可用 hi/ur 等）
                CZ: "cs",  // 捷克 -> 捷克语
                SK: "sk",  // 斯洛伐克 -> 斯洛伐克语
                ZA: "en",  // 南非 -> 英语
                HU: "hu",  // 匈牙利 -> 匈牙利语
                IE: "en"   // 爱尔兰 -> 英语
            },
        };
    },
    watch: {
        targetCountry: {
            handler(val) {
                this.targetLanguage = this.countryLangMap[this.targetCountry] || '';
            },
            immediate: true // 首次加载就执行一次监听逻辑
        }
    },
    methods: {
        // 翻译所有图片
        translationAll(){
            if(this.status == 'translating'){
                this.$message.warning("正在翻译。。。")
                return
            }
            if(!this.targetLanguage){
                this.$message.error("请输入目标语言")
                return
            }
            if(this.sourceLanguage == this.targetLanguage){
                this.$message.error("源语言和目标语言不能一样")
                return
            }
            let imgData = [];
            if(this.getParentData){ // 获取父组件数据
                imgData = this.getParentData() || [];
            }else{
                imgData = this.imgList;
                if(this.imgList.length === 0){
                    this.$message.error('请先选择图片');
                    return;
                }
            }
            if(imgData.length === 0){
                this.$message.error('没有可翻译的图片');
                return;
            }
            this.status = 'translating';
            const runner = new ConcurrentRunner(5); // 最大5个并发
            const promises = [];
            for (let i = 0; i < imgData.length; i++) {
                promises.push(runner.addTask(() => this.translateImages(imgData[i])));
            }
            Promise.all(promises).then((results)=>{
                this.$emit('onTranslation', results.filter(item => item && item.res && item.res.data));
                this.status = 'success';
            }).catch((error)=>{
                console.error('翻译图片出错:', error);
                this.status = 'error';
            });
            // 
        },
        // 翻译图片
        async translateImages({src, name}) {
            const params = {
                imageUrl: src,
            }
            if(this.sourceLanguage){
                params.sourceLanguage = this.sourceLanguage;
            }
            if(this.targetLanguage){
                params.targetLanguage = this.targetLanguage;
            }
            const res1 = await fetch("https://hx1.hyxun.top/api/imageTranslation", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(params)
            });
            const res = await res1.json();
            if(!res.success){
                this.$message.error(res.data);
                return
            }
            return {
                sourceImg: src,
                name: name || '',
                res,
            };
        },
    },
    created() {},
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.ImageTranslation-container{
    display: flex;
    align-items: center;
    .status-text{
        margin-left: 20px;
        font-weight: bold;
        color: #409EFF;
    }
    .text-item{
        display: flex;
        align-items: center;
        margin-right: 20px;
        span{
            margin-right: 8px;
            white-space: nowrap;
        }
    }
}
</style>